module.exports = __webpack_public_path__ + "static/media/29COICT6.a39e5e59.jpg";